import {
  Drawer,
  DrawerContent,
  DrawerHeader
} from '@library/components/navigation';
import { Avatar } from '@library/components/avatar/Avatar';
import { DateTime } from 'luxon';
import type { GetChannelDetailsResponse } from '@library/types/alerts';

export const ChannelDetailsDrawer = ({
  channelDetails,
  drawerOpen,
  handleCancelDrawer
}: {
  channelDetails: GetChannelDetailsResponse | undefined;
  drawerOpen: boolean;
  handleCancelDrawer: () => void;
}) => {
  const date = DateTime.fromISO(
    channelDetails?.data?.attributes.created_at || ''
  );

  return (
    <Drawer
      direction="right"
      isOpen={drawerOpen}
      onCloseDrawer={handleCancelDrawer}
      size="small"
    >
      <DrawerHeader subtitle="Alerts" onClickClose={handleCancelDrawer}>
        Channel Details
      </DrawerHeader>
      <DrawerContent className="flex w-full flex-col gap-4 overflow-auto p-6">
        <div className="border-soFresh-140 flex flex-col gap-4 border-b pb-6">
          <p className="text-sm font-semibold">About</p>
          <div className="flex flex-col gap-2 text-sm">
            <div className="flex w-11/12 justify-between">
              <p>Creation Date</p>
              <p>{date.toLocaleString()}</p>
            </div>
            <div className="flex w-11/12 justify-between">
              <p>Messages</p>
              <p>{channelDetails?.data?.attributes?.message_count}</p>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-4 pb-1">
          <p className="text-sm font-semibold">Members</p>
          <div className="flex flex-col gap-2 text-sm">
            {!channelDetails?.included && (
              <p className="text-base">
                There are no users subscribed to this channel
              </p>
            )}
            {channelDetails?.included &&
              channelDetails.included.map((channelUser) => {
                return (
                  channelUser.attributes.first_name !== '' &&
                  channelUser.attributes.last_name !== '' && (
                    <div
                      className="border-soFresh-140 mx-3 my-2 flex items-center border-b p-2"
                      key={`${channelUser.id}`}
                    >
                      <Avatar />
                      <p className="ml-3">
                        {`@${channelUser.attributes.first_name} ${channelUser.attributes.last_name}`}
                      </p>
                    </div>
                  )
                );
              })}
          </div>
        </div>
      </DrawerContent>
    </Drawer>
  );
};
